import Company from "./company.js";
export default Company;